import React from "react";

export default function VehicleDeliveryGreetings({ data, loading, children }) {
  return <div>{children}</div>;
}
